<div class="h-100 w-100">
    <div class="echart" *ngIf="selfServiceChartAttributes?.chartAttributes?.chartType?.value === 'bar'">
      <div *ngIf="isloader" class="h-100 w-100 padt-5">
        <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
      </div> 
      <app-bar-echart *ngIf="!isloader" class="echart" [xAxis]="chartData?.xAxis" [tooltip]="chartData?.tooltip" [title]="chartData?.title" [yAxis]="chartData?.yAxis" [series]="chartData?.series" [grid]="chartData?.grid" (chartClick)="onChartClick($event)"></app-bar-echart>
    </div>
    <div class="echart" *ngIf="selfServiceChartAttributes?.chartAttributes?.chartType?.value === 'histogram'">
      <div *ngIf="isloader" class="h-100 w-100 padt-5">
        <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
      </div> 
        <app-histogram *ngIf="!isloader" class="echart" [histogramData]="entityHistogramAtrributes" [barCount]="barCount" [barWidth]="barWidth" [isMock]="false" [markline]="markLine"
          [barName]=""
          [barName2]="'Occurence Count'"
          [binCountType]="'binWidth'" >
        </app-histogram>
    </div>
    <div class="echart" *ngIf="selfServiceChartAttributes?.chartAttributes?.chartType?.value === 'stacked-bar'">
      <div *ngIf="isloader" class="h-100 w-100 padt-5">
        <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
      </div> 
      <app-stacked-bar *ngIf="!isloader" class="echart" [graphData]="graphData"[stackedBarChartTitle]="stackedBarChartTitle" [xAxisLabel]="xAxisLabel" [graphAxisDetails]="graphAxisDetails" (chartClick)="onChartClick($event)">
    </app-stacked-bar>
      </div>
    <div class="echart" *ngIf="selfServiceChartAttributes?.chartAttributes?.chartType?.value === 'mock-line1' || selfServiceChartAttributes?.chartAttributes?.chartType?.value === 'mock-line2'">
        <div *ngIf="isloader" class="h-100 w-100 padt-5">
          <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
        </div> 
        <app-line-echart *ngIf="!isloader" class="echart" [xAxis]="chartData?.xAxis" [yAxis]="chartData?.yAxis" [series]="chartData?.series" [title]="chartData?.title" [tooltip]="chartData?.tooltip" [grid]="chartData?.grid"></app-line-echart>
    </div>
</div>